export default __webpack_public_path__ + "static/media/novembazar_raffle_gold.5e0692b4.png";